import React from "react"
import PropTypes from "prop-types"

import UpcomingMeetingsContainer from './UpcomingMeetingsContainer';
import PastMeetingsContainer from './PastMeetingsContainer';
import LoaderSection from '../app_components/LoaderSection';

class MeetingViewContainer extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      upcomingMeetings: [],
      pastMeetings: [],
      totalMeetingCount: '',
      currentUserId: '',
      loaded: false
    }

    this.getAllMeetings = this.getAllMeetings.bind(this)
  }

  componentDidMount() {
    //ajax - get all meetings
    //getAllMeetings
    this.getAllMeetings()
  }

  getAllMeetings() {
    $.ajax({
      url: `../getAllMeetings`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          upcomingMeetings: JSON.parse(data.data.upcoming_meetings),
          pastMeetings: JSON.parse(data.data.past_meetings),
          totalMeetingCount: data.data.total_meetings,
          currentUser: JSON.parse(data.data.currentUser),
          loaded: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  render() {
    if(!this.state.loaded) {
      return <LoaderSection />
    }

    return(
      <div>
        <UpcomingMeetingsContainer
          meetings={this.state.upcomingMeetings}
          totalMeetingCount={this.state.totalMeetingCount}
          currentUser={this.state.currentUser}
          getAllMeetings={this.getAllMeetings}
         />
        {this.state.pastMeetings.length > 0 &&
          <PastMeetingsContainer
            meetings={this.state.pastMeetings}
            totalMeetingCount={this.state.totalMeetingCount}
            currentUser={this.state.currentUser}
            getAllMeetings={this.getAllMeetings}
          />}

      </div>
    )
  }

}

export default MeetingViewContainer;
